import { formatDate } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    FilterParams,
    FiltersService,
} from 'app/layout/common/filters/filters.service';
import { GeneralResponse } from 'app/models/general-response.model';
import { Order } from 'app/models/orders.model';
import { environment } from 'environments/environment';
import {
    BehaviorSubject,
    Observable,
    catchError,
    of,
    shareReplay,
    switchMap,
    take,
    tap,
} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OrdersStore {
    /**
     * Objects
     */
    // Keep previous and current values using BehaviorSubject
    private _orders = new BehaviorSubject<GeneralResponse>(null);
    // Emmit the behavioralSubject value and restrict access the date since it is private
    // So component can subscribe and get the values without being able to emmit new ones
    // themselves
    orders$: Observable<GeneralResponse> = this._orders.asObservable();

    /**
     * Constructor
     * @param _http
     * @param _filtersService
     */
    constructor(
        private _http: HttpClient,
        private _filtersService: FiltersService
    ) {}

    private _selectedOrder = new BehaviorSubject<Order | null>(null);
    selectedOrder$ = this._selectedOrder.asObservable();

    setSelectedOrder(order: Order): void {
        this._selectedOrder.next(order);
    }

    // -----------------------------------------------------------------------------------------------------
    // Private methods
    // -----------------------------------------------------------------------------------------------------

    get(filter: FilterParams): Observable<GeneralResponse> {
        let params = new HttpParams();
        filter.site
            ? (params = params.append('sites', filter.site.toString()))
            : null;
        filter.cfms_site
            ? (params = params.append('cfmsSites', filter.cfms_site.toString()))
            : null;
        filter.from
            ? (params = params.append(
                  'from',
                  formatDate(filter.from, 'dd/MM/yyyy', 'el')
              ))
            : null;
        filter.to
            ? (params = params.append(
                  'to',
                  formatDate(filter.to, 'dd/MM/yyyy', 'el')
              ))
            : null;
        return this._http
            .get<GeneralResponse>(
                `${environment.backendURL}${environment.ordersSummaryURL}`,
                { params: params }
            )
            .pipe(
                // Handle error
                catchError((err) => {
                    console.log(err);
                    let customResponse = {
                        code: err.status,
                        msg: 'Could not load data',
                    } as GeneralResponse;
                    return of(customResponse);
                }),
                tap((response: GeneralResponse) => {
                    this._orders.next(response);
                }),
                // Specify how many values we need before we unsubscribe
                take(1),
                // avoid retrigering the HTTP request whenever a new subscriber is registered
                // by sharing the last value of this stream
                shareReplay()
            );
    }

    // -----------------------------------------------------------------------------------------------------
    // Public methods
    // -----------------------------------------------------------------------------------------------------

    getFilters(): Observable<any> {
        return this._filtersService.filter$.pipe(
            // We use switchMap so when a value is emitted from filterService we change the subscription to another observable
            // We get params which is the FilterParams fron fitlerService filter$
            switchMap((params: FilterParams) => {
                // Update filter view to display all filter subtitle on dense layout
                console.log(params);
                this._filtersService.updateInUseFilters(true, true, true);
                return this.get(params);
                // Create a hashString of the emitted value
                // let hashString: string = objectHash(params);

                // // Compare last filter hashed value to the current one
                // if (this.hashedFilters !== hashString) {
                //     // Save new hash value
                //     this.hashedFilters = hashString;

                //     // Return new observable with combine latest
                //     return this.get(params);

                // } else {

                //     // Return observable of null to close the resolver
                //     return of(null);
                // }
            }),
            // Specify how many values we need before we unsubscribe
            // take(1),
            // avoid retrigering the HTTP request whenever a new subscriber is registered
            // by sharing the last value of this stream
            shareReplay()
        );
    }

    public updateOrder(orders: Order[]): Observable<GeneralResponse> {
        return this._http
            .put<GeneralResponse>(
                `${environment.backendURL}${environment.ordersVechilesURL}/update`,
                orders
            )
            .pipe(
                // Handle error
                catchError((err) => {
                    console.log(err);
                    let customResponse = {
                        code: err.status,
                        msg: 'Could not load data',
                    } as GeneralResponse;
                    return of(customResponse);
                }),
                tap((response: GeneralResponse) => {})
            );
    }
}
